export default function imageLoaded() {
  document.querySelectorAll('.js-imageloaded').forEach((element) => {
    imagesLoaded(element, { background: '*' }, () => {
      element.classList.add('-imageloaded');
    });
  });
}
